<div class="w-100">
  <mwp-card-content-header [url]="apiUrl" />
  @if (!displayAgentForm) {
  <div class="mt-3">
    <div class="content-container mb-3">
      <div class="title d-inline-flex w-100">
        <mwp-text-translate text="Agents" jsonKey="agents" />
      </div>
      <div class="content">
        <form [formGroup]="agentControlForm">
          <div class="w-100 d-flex">
            <div class="col-4 pb-3">
              <mwp-dropdown [form]="agentControlForm" nameForControl="brokerId" [data]="brokers" keyText="name" keyValue="id" (emitSelected)="brokerChange($event)" labelName="Select Broker" />
            </div>
            <div class="col-6 pb-3">
              <mat-checkbox [checked]="includeDisabled" class="fw-bold" (change)="includeDisableChange($event)">
                <mwp-text-translate text="Include Disabled" jsonKey="includeDisabled" />
              </mat-checkbox>
            </div>
            <div class="col-2 d-flex justify-content-end pb-3">
              <button class="mwp-button-save " (click)="newAgent()">
                <mwp-text-translate text="New Agent" jsonKey="newAgent" />
              </button>
            </div>
          </div>
        </form>
        @if (agentForm) {
        <div class="mb-3">
          <mwp-table-formarray [form]="agentForm" [arrayName]="agentFormArrayName" [tableColumns]="agentColumns" [dataSource]="agentMatTableData" (emitHyperLink)="editAgent($event)" />
        </div>
        }
        @if (agentForm) {
        <div class="d-inline-flex justify-content-end w-100">
          <button class="mwp-button-save" [disabled]="agentForm.pristine" (click)="saveDisabledList()">
            <mwp-text-translate text="Save" jsonKey="save" />
          </button>
        </div>
        }
      </div>
    </div>
  </div>
  }
  @if (displayAgentForm) {
  <div>
    <mwp-agent-form [agent]="selectedAgentUser" [hasAccessToAllBrokers]="hasAccessToAllBrokers" (emitCancel)="cancelEdit()" (emitSave)="saveAgentResponse()" />
  </div>
  }
</div>